import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import BuildingsApi from "../../api/BuildingsApi";
import AuthService from "../../session/AuthService";
import TaskApi from "../../api/TaskApi";
import { Select } from "antd";

class TaskCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        resourseDate: null,
        employeeid: 0,
        allowServiceRecord: false,
        resourseType: 4,
      },
      whichdropDown: "Resource",
      selectedOptionText: "",
      commonArrays: [],
      colorChange2: false,
      colorChange1: false,
      colorChange3: false,
    };
  }

  componentDidMount = async () => {
    this.setState({
      colorChange2: true,
      colorChange1: true,
    });

    console.log("componentDidMount", this.props.editValue);
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      const { resourseType } = this.props.editValue;

      // Function to handle each API call and wait for its completion
      const handleApiCall = async (apiFunction) => {
        try {
          const response = await apiFunction(); // Await the API call to complete
          return response;
        } catch (error) {
          console.error("Error in API call:", error);
          throw error; // Rethrow the error to be caught later
        }
      };

      try {
        if (resourseType === parseInt("1")) {
          await handleApiCall(this.togetBuildingdata);
        } else if (resourseType === parseInt("2")) {
          await handleApiCall(this.togetEquipmentdata);
        } else if (resourseType === parseInt("3")) {
          await handleApiCall(this.togetvechileData);
        }

        this.setState(
          {
            formValues: this.props.editValue,
            colorChange2: true,
            colorChange1: true,
            colorChange3: true,
          },
          () => {
            console.log("this.edit.formvalues", this.state.formValues);
          }
        );
      } catch (error) {
        console.error("Error in API calls:", error);
      }
    }
  };

  render() {
    const { formValues, colorChange1, colorChange2, colorChange3 } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit" ? "Edit Task" : "Create New Task"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Task Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Task Name"
                autoFocus
                className="small-input"
                name="taskName"
                value={formValues.taskName}
                onChange={this.onTaskChange}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Choose Employee</Form.Label>
              <Select
                showSearch
                className="w-100 farm-cutomselect"
                value={formValues.employeeid}
                name="employeeid"
                getPopupContainer={(e) => e.parentNode}
                onChange={(value) =>
                  this.onTaskChange({ target: { name: "employeeid", value } })
                } // Better-defined onChange
                disabled={AuthService.getUserTypeAdmin() === "3"}
                optionFilterProp="label" // Allows search on the label text
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={[
                  { value: 0, label: "All" },
                  ...(this.props.userList && this.props.userList.length > 0
                    ? this.props.userList.map((data) => ({
                        value: data.id,
                        label: `${data.firstName} ${data.lastName || ""}`, // Concatenated names
                      }))
                    : []),
                ]}
              />
            </Form.Group>

            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Category</Form.Label>
              <Select
                showSearch
                className="w-100 farm-cutomselect"
                value={formValues.resourseType}
                name="resourseType"
                getPopupContainer={(e) => e.parentNode}
                onChange={(value) =>
                  this.onTaskChange({ target: { name: "resourseType", value } })
                }
                disabled={AuthService.getUserTypeAdmin() === "3"}
                optionFilterProp="label" // Allows search on the label text
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "",
                    label: "Choose Resourse",
                  },
                  {
                    value: 1,
                    label: "Building",
                  },
                  {
                    value: 2,
                    label: "Equipment",
                  },
                  {
                    value: 3,
                    label: "Vehicle",
                  },
                  {
                    value: 4,
                    label: "None",
                  },
                ]}
              />
            </Form.Group>
            {String(this.state.formValues.resourseType) !== "4" && (
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Resource</Form.Label>
                
                <Select
                  showSearch
                  className="w-100 farm-cutomselect"
                  value={formValues.resourseValue}
                  name="resourseValue"
                  getPopupContainer={(e) => e.parentNode}
                  onChange={(value) =>
                    this.onTaskChange({
                      target: { name: "resourseValue", value },
                    })
                  }
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={[
                    { value: "", label: "Choose Resource" },
                    ...(String(formValues.resourseType) === "1"
                      ? this.state.commonArrays.map((e) => ({
                          value: e.building_id,
                          label: this.capitalizeFirstLetter(e.building_name),
                        }))
                      : String(formValues.resourseType) === "2"
                      ? this.state.commonArrays.map((e) => ({
                          value: e.equipmentId,
                          label: this.capitalizeFirstLetter(e.equipmentName),
                        }))
                      : String(formValues.resourseType) === "3"
                      ? this.state.commonArrays.map((e) => ({
                          value: e.vehicle_id,
                          label: this.capitalizeFirstLetter(e.vehicle_name),
                        }))
                      : []),
                  ]}
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Description"
                autoFocus
                className="small-input"
                name="taskDesc"
                value={formValues.taskDesc}
                onChange={this.onTaskChange}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            {String(this.state.formValues.resourseType) !== "4" && (
              <>
                <input
                  type="checkbox"
                  id="allowServiceRecord"
                  name="allowServiceRecord"
                  checked={formValues.allowServiceRecord}
                  onChange={this.handleChecked}
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                />
                <label
                  htmlFor="allowServiceRecord"
                  style={{ paddingLeft: "10px" }}
                >
                  Service Record Required Upon Completion
                </label>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Close
            </Button>
            <Button variant="success" onClick={this.SaveForm}>
              {this.props.option === "edit" ? "Edit Task" : "Create Task"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  handleChecked = () => {
    this.setState(
      (prevState) => ({
        formValues: {
          ...prevState.formValues,
          allowServiceRecord: !prevState.formValues.allowServiceRecord,
        },
      }),
      () => {
        console.log(
          "Updated allowServiceRecord:",
          this.state.formValues.allowServiceRecord
        );
      }
    );
  };

  handleDateChange = (date) => {
    if (date) {
      // Check if date is not null or undefined
      console.log("date", date.toString());

      let form = this.state.formValues || {}; // Provide a default empty object if formValues is not available

      form["resourseDate"] = date.toString();
      this.setState(
        {
          formValues: form,
        },
        () => {
          console.log("date", date.toString());
        }
      );
    }
  };

  onTaskChange = (event) => {
    const { name, value } = event.target;
    console.log("event", event.target.value);
    console.log("event", event.target.name);

    const form = { ...this.state.formValues };

    if (name === "employeeid") {
      this.setState({
        colorChange1: true,
      });
    } else if (name === "resourseType") {
      this.setState({
        colorChange2: true,
      });
      form["resourseValue"] = "";
    } else if (name === "resourseValue") {
      this.setState({
        colorChange3: true,
      });
    }

    form[name] = value;
    this.setState({ formValues: form }, () => {
      if (name === "resourseType") {
        if (this.state.formValues.resourseType === 1) {
          this.togetBuildingdata();
        } else if (this.state.formValues.resourseType === 2) {
          this.togetEquipmentdata();
        } else if (this.state.formValues.resourseType === 3) {
          this.togetvechileData();
        } else {
        }
      }
    });
  };

  // onChangeEmployee = (data) => {
  //   // alert(data);
  //   this.setState({
  //     colorChange1: true,
  //   });
  //   const form = { ...this.state.formValues };
  //   form["employeeid"] = data;
  //   console.log(form);
  // };

  togetBuildingdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getBuildingData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState(
          {
            commonArrays: response.data.data.buildingData,
          },
          () => {
            console.log("this is ", this.state.commonArrays);
          }
        );
      } else {
      }
    });
  };

  togetEquipmentdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getEquipmentData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.equipmentData,
        });
      } else {
      }
    });
  };

  togetvechileData = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getVehicleData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.vehicleData,
        });
      } else {
      }
    });
  };

  SaveForm = () => {
    console.log("formvalues", this.state.formValues);
    const { formValues } = this.state;

    if (this.props.option === "edit") {
      if (!this.state.formValues.taskName) {
        this.props.errorToast("Please Enter the Task Name");
      } else if (
        !this.state.formValues.resourseType ||
        this.state.formValues.resourseType === "Choose Category"
      ) {
        this.props.errorToast("Please Choose the Category");
      } else if (!this.state.formValues.taskDesc) {
        this.props.errorToast("Please Enter  the Task Description");
      } else if (
        (!this.state.formValues.resourseValue ||
          this.state.formValues.resourseValue === "Choose Resource") &&
        (!this.state.formValues.resourseType ||
          this.state.formValues.resourseType === "Choose Category" ||
          String(this.state.formValues.resourseType) !== "4")
      ) {
        this.props.errorToast("Please Choose the Resource");
      } else {
        let obj = {
          taskName: formValues.taskName,
          employeeid: parseInt(formValues.employeeid),
          resourseType: parseInt(formValues.resourseType),
          resourseValue: parseInt(formValues.resourseValue),
          taskDesc: formValues.taskDesc,
          taskId: this.props.editValue.taskId,
          group_id: parseInt(AuthService.getUserId()),
          note: "",
          allowServiceRecord: formValues.allowServiceRecord,
        };

        TaskApi.editTask(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.completeTaskOnLoad();
            this.props.handleClose();
            this.props.renderToast("Edit");
          }
        });
      }
    } else {
      if (!this.state.formValues.taskName) {
        this.props.errorToast("Please Enter the Task Name");
      } else if (
        !this.state.formValues.resourseType ||
        this.state.formValues.resourseType === "Choose Category"
      ) {
        this.props.errorToast("Please Choose the Category");
      } else if (!this.state.formValues.taskDesc) {
        this.props.errorToast("Please Enter the Task Description");
      } else if (
        (!this.state.formValues.resourseValue ||
          this.state.formValues.resourseValue === "Choose Resource") &&
        (!this.state.formValues.resourseType ||
          this.state.formValues.resourseType === "Choose Category" ||
          String(this.state.formValues.resourseType) !== "4")
      ) {
        this.props.errorToast("Please Choose the Resource");
      } else {
        let obj = {
          taskName: formValues.taskName,
          employeeid: parseInt(formValues.employeeid),
          resourseType: parseInt(formValues.resourseType),
          resourseValue: parseInt(formValues.resourseValue),
          taskDesc: formValues.taskDesc,
          group_id: parseInt(AuthService.getUserId()),
          note: "",
          allowServiceRecord: formValues.allowServiceRecord,
        };

        TaskApi.saveTask(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.onLoad();
            this.props.handleClose();
            this.props.renderToast("Create");
          }
        });
      }
    }
  };
}
export default TaskCreate;
